import { render } from "./CatalogDetails.vue?vue&type=template&id=5ce54962&ts=true&lang=pug"
import script from "./CatalogDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogDetails.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__